import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=15debd89&scoped=true"
import script from "./TheLayout.vue?vue&type=script&lang=js"
export * from "./TheLayout.vue?vue&type=script&lang=js"
import style0 from "./TheLayout.vue?vue&type=style&index=0&id=15debd89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15debd89",
  null
  
)

export default component.exports